
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.781 20.375l-8-10A1 1 0 0023 10H9a1 1 0 00-.781.375l-8 10A1 1 0 000 21v9a2 2 0 002 2h28a2 2 0 002-2v-9c0-.227-.077-.447-.219-.625zM30 22h-7l-4 4h-6l-4-4H2v-.649L9.481 12H22.52l7.481 9.351V22z"}})])
          )
        }
      }
    